export enum LiquidProductionTATEnum {
    TopLevel = 100654,
    InterfaceLevel = 100655,
    OilHeight = 100656,
    WaterHeight = 100657,
    OilStock = 100658,
    WaterStock = 100659,
    OilHaul = 100641,
    WaterHaul = 100642,
    DailyOilProduction = 102643,
    DailyWaterProduction = 102644,
    CapacityFilled = 100662
}